import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize' })
export class CapitalizeString implements PipeTransform {
    constructor() {}
    transform(value: string): string {
        let newStr: string = '';
        let finalString: string = '';
        if (value) {
            for (var i = 0; i < value.length; i++) {
                if (value.charAt(i) === '_') {
                    newStr += ' ';
                } else {
                    newStr += value.charAt(i);
                }
            }
            newStr = newStr.toLowerCase();
            let newStrList = newStr.split(' ');
            for (var i = 0; i < newStrList.length; i++) {
                finalString += newStrList[i].charAt(0).toUpperCase() + newStrList[i].slice(1) + ' ';
            }
            return finalString.trim();
        }
        return '';
    }
}
